import { type JSX, useCallback, useState } from 'react';

import type { OddsFormat } from '@cx-modules/types';

import { MobileOnly } from '../../OddsGrid.style';
import type { Bet, OnOddsButtonClick } from '../../types';
import { BetColumnTop } from '../BetColumnTop';
import { OddsOffersCells } from '../OddsOffersCells';

interface BetRowProps {
  bet: Bet;
  betsWithBestOdds: (Bet & { bestOdds: number; bestOddsFractional: string; bestOddsText: string | number })[];
  defaultExpanded?: boolean;
  disableStreamer: boolean;
  index?: number;
  isTabletOrDesktop: boolean;
  marketId: number;
  oddsFormat: OddsFormat;
  onOddsButtonClick?: OnOddsButtonClick;
  renderBadge: boolean;
  showCompareOddsToolTip: boolean;
  tooltipForNewUser?: boolean;
}

export function BetRow({
  bet,
  betsWithBestOdds,
  defaultExpanded = false,
  disableStreamer,
  index,
  isTabletOrDesktop,
  marketId,
  oddsFormat,
  onOddsButtonClick,
  renderBadge,
  showCompareOddsToolTip,
  tooltipForNewUser,
}: BetRowProps): JSX.Element {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const bestOddBet = betsWithBestOdds.find(b => b.id === bet.id);
  const isOpen = isExpanded || isTabletOrDesktop;

  const handleToggle = useCallback(() => {
    setIsExpanded(prev => !prev);
  }, []);

  return (
    <>
      <MobileOnly>
        <BetColumnTop
          bestOddBet={bestOddBet}
          betId={bet.id}
          disableStreamer={disableStreamer}
          isOpen={isOpen}
          marketId={marketId}
          onOddsButtonClick={onOddsButtonClick}
          renderBadge={renderBadge}
          showCompareOddsToolTip={showCompareOddsToolTip}
          showNewUserTooltip={index === 0 && tooltipForNewUser}
          toggle={handleToggle}
        />
      </MobileOnly>
      {isOpen && <OddsOffersCells bet={bet} betsWithBestOdds={betsWithBestOdds} oddsFormat={oddsFormat} />}
    </>
  );
}
